<template>
  <div class="finance-base-bill accounts-registration-msg-bill">
    <div class="header">
      <div class="btn-container">
        <el-button
          v-if="curAuth.includes('addPayMsg')"
          :disabled="!outerItem"
          type="primary"
          icon="el-icon-plus"
          @click="addPaymentInfo"
        >{{ $t('fms_accounts_registration_msg_bill.tian_jia_jiao_yi') }}</el-button>
      </div>
    </div>
    <custom-table
      :slots="['tradeResult', 'action', 'buyerTradeRemark', 'payMsg', 'receiveMsg', 'isConfirm']"
      class="bill-list"
      :tableCode="tableCode"
      :data="data"
      :filterArr="filterArr"
      @filter="filterChange"
      @sort="sortChange"
      :expand="expandFlowMsg"
      :row-key="getRowId"
      :expand-row-keys="expandKeys"
      ref="table"
      :rowClassName="rowClassName"
    >
      <template v-slot:expand="scope">
        <el-row :gutter="15">
          <el-col :span="8">
            {{ $t('fms_accounts_registration_msg_bill.sklsh') }}： {{scope.row.sellerTradeCode || '-'}}
          </el-col>
          <el-col :span="8">
            {{ $t('fms_accounts_registration_msg_bill.dao_zhang_shi_jian') }}： {{formatedList[scope.$index].tradeMsg.tradeFinishTime ? momentAmPm($momentLocal(formatedList[scope.$index].tradeMsg.tradeFinishTime, 'YYYY-MM-DD HH:mm:ss')) : (scope.row.receiveTime || '-') }}
          </el-col>
          <el-col :span="8">
            {{ $t('fms_accounts_registration_msg_bill.shou_kuan_zhai_yao') }}： {{formatedList[scope.$index].tradeMsg.buyerTradeRemark || scope.row.receiveRemark || '-'}}
          </el-col>
        </el-row>
      </template>
      <template
        v-slot:payMsg="scope"
        v-if="!isReverse"
      >
        <div
          class="msg-item"
          v-if="scope.row.tradeMethod == '50'"
        >
          {{ $t('fms_accounts_registration_msg_bill.fu_kuan_ren') }}：{{scope.row.buyerAccount}}
        </div>
        <div v-if="scope.row.tradeMethod == '1' && formatedList && formatedList.length">
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.zhang_hu_ming_cheng') }}：{{formatedList[scope.$index].payMsg.accountName}}</div>
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.yin_hang_zhang_hu') }}：{{formatedList[scope.$index].payMsg.account}}</div>
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.kai_hu_yin_hang') }}：{{formatedList[scope.$index].payMsg.bank}}</div>
        </div>
      </template>
      <template
        v-slot:payMsg="scope"
        v-else
      >
        <div
          class="msg-item"
          v-if="scope.row.tradeMethod == '50'"
        >
          {{ $t('fms_accounts_registration_msg_bill.fu_kuan_ren') }}：{{scope.row.sellerAccount}}
        </div>
        <div v-if="scope.row.tradeMethod == '1' && formatedList && formatedList.length">
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.zhang_hu_ming_cheng') }}：{{formatedList[scope.$index].receiveMsg.accountName}}</div>
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.yin_hang_zhang_hu') }}：{{formatedList[scope.$index].receiveMsg.account}}</div>
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.kai_hu_yin_hang') }}：{{formatedList[scope.$index].receiveMsg.bank}}</div>
        </div>
      </template>
      <template
        v-slot:receiveMsg="scope"
        v-if="!isReverse"
      >
        <div
          class="msg-item"
          v-if="scope.row.tradeMethod == '50'"
        >
          {{ $t('fms_accounts_registration_msg_bill.shou_kuan_ren') }}：{{scope.row.sellerAccount}}
        </div>
        <div v-if="scope.row.tradeMethod == '1' && formatedList && formatedList.length">
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.zhang_hu_ming_cheng') }}：{{formatedList[scope.$index].receiveMsg.accountName}}</div>
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.yin_hang_zhang_hu') }}：{{formatedList[scope.$index].receiveMsg.account}}</div>
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.kai_hu_yin_hang') }}：{{formatedList[scope.$index].receiveMsg.bank}}</div>
        </div>
      </template>
      <template
        v-slot:receiveMsg="scope"
        v-else
      >
        <div
          class="msg-item"
          v-if="scope.row.tradeMethod == '50'"
        >
          {{ $t('fms_accounts_registration_msg_bill.shou_kuan_ren') }}：{{scope.row.buyerAccount}}
        </div>
        <div v-if="scope.row.tradeMethod == '1' && formatedList && formatedList.length">
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.zhang_hu_ming_cheng') }}：{{formatedList[scope.$index].payMsg.accountName}}</div>
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.yin_hang_zhang_hu') }}：{{formatedList[scope.$index].payMsg.account}}</div>
          <div
            class="msg-item"
          >{{ $t('fms_accounts_registration_msg_bill.kai_hu_yin_hang') }}：{{formatedList[scope.$index].payMsg.bank}}</div>
        </div>
      </template>
      <template v-slot:tradeResult="scope">
        <el-image
          v-if="scope.row.attachs && scope.row.attachs.length"
          style="width:69px;height: 69px;"
          :src="getAttachUrl(scope.row.attachs[0])"
          :preview-src-list="[getAttachUrl(scope.row.attachs[0])]"
          fit="contain"
        ></el-image>
      </template>
      <template v-slot:isConfirm="scope">
        <span v-if="scope.row.sellerTradeCode">{{ $t('fms_accounts_registration_msg_bill.yi_shou_kuan') }}</span>
        <span
          v-else
          class="red-font"
        >{{ $t('fms_accounts_registration_msg_bill.wei_shou_kuan') }}</span>
      </template>
      <template
        v-if="showAction"
        v-slot:action="scope"
      >
        <span></span>
        <el-button
          v-if="curAuth.includes('del')"
          type="text"
          size="mini"
          @click="del(scope)"
          :disabled="!!scope.row.sellerTradeCode"
        >{{ $t('Common.com_delete') }}</el-button>
        <el-button
          v-if="curAuth.includes('edit')"
          type="text"
          size="mini"
          @click="edit(scope)"
          :disabled="!!scope.row.sellerTradeCode"
        >{{ $t('Common.com_edit') }}</el-button>
        <el-button
          v-if="curAuth.includes('relativeFlow') && !scope.row.sellerTradeCode && bindFlowEnable(scope.row)"
          type="text"
          size="mini"
          @click="relative(scope.row)"
        >{{ isRefundBill ? $t('fms_accounts_registration_msg_bill.que_ren_tui_kuan') : $t('fms_accounts_registration_msg_bill.que_ren_shou_kuan') }}</el-button>
        <el-button
          v-if="curAuth.includes('relativeFlow') && scope.row.sellerTradeCode && bindFlowEnable(scope.row)"
          type="text"
          size="mini"
          @click="onDelBankFlow(scope.$index, !scope.row.tradeId )"
        >{{ isRefundBill ? $t('fms_accounts_registration_msg_bill.qu_xiao_tui_kuan') : $t('fms_accounts_registration_msg_bill.qu_xiao_shou_kuan') }}</el-button>
      </template>
      <template v-slot:buyerTradeRemark="scope">
        {{scope.row.buyerTradeRemark | tradeRemark}}
      </template>
    </custom-table>
    <!-- <payable-balance-detail-dialog
      v-if="showBalanceDetail"
      :billType="billType"
      :receivableOrgId="outerItem.receivableOrgId"
      :payableOrgId="outerItem.payableOrgId"
      :billId="outerItem.billId"
      @close="showBalanceDetail = false"
    ></payable-balance-detail-dialog> -->
    <!-- 关联银行流水 -->
    <bind-bank-flow-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
      @success="onBind"
      :sellerTradeType="sellerTradeType"
    ></bind-bank-flow-dialog>
    <pay-type-dialog
      v-if="payTypeDialogVisible"
      @close="payTypeDialogVisible = false"
      :model="{title: $t('fms_accounts_registration_msg_bill.jiao_yi_fang_shi')}"
      @confirm="onPayTypeConfirm"
    ></pay-type-dialog>
    <add-pay-info-public-step1-dialog
      v-if="addPayInfoPublicStep1DialogVisible"
      @close="addPayInfoPublicStep1DialogVisible=false"
      :model="payInfoModel"
      :totalAmount="amount"
      :paymentCode="getPaymentCode(billInfo)"
      :isReverse="isReverse"
      @confirm="step1Confirm"
      :paymentOrReceivable="paymentOrReceivable"
      @update:sellerBank="getSelllerAccountList"
      @update:buyerBank="getBuyerAccountList"
      @edit:buyer="onEditBuyerMsg"
      @edit:seller="onEditSellerMsg"
      @add:buyer="onAddBuyerMsg"
      @add:seller="onAddSellerMsg"
      :accountManage="accountManage"
    ></add-pay-info-public-step1-dialog>
    <add-pay-info-public-step2-dialog
      v-if="addPayInfoPublicStep2DialogVisible"
      @close="addPayInfoPublicStep2DialogVisible=false"
      :model="payInfoModel"
      :totalAmount="amount"
      :paymentCode="getPaymentCode(billInfo)"
      :isReverse="isReverse"
      @edit="onEditPayInfoHandler"
      :paymentOrReceivable="paymentOrReceivable"
      @update:sellerBank="getSelllerAccountList"
      @update:buyerBank="getBuyerAccountList"
      @edit:buyer="onEditBuyerMsg"
      @edit:seller="onEditSellerMsg"
      @add:buyer="onAddBuyerMsg"
      @add:seller="onAddSellerMsg"
      :accountManage="accountManage"
    ></add-pay-info-public-step2-dialog>
    <add-pay-info-pay-msg-dialog
      v-if="addPayInfoPayMsgDialogVisible"
      @close="addPayInfoPayMsgDialogVisible=false"
      :model="payInfoModel"
      :totalAmount="amount"
      :orderNum="getPaymentCode(billInfo)"
      :isReverse="isReverse"
      @add="step1Confirm"
      @edit="onEditPayInfoHandler"
      :paymentOrReceivable="paymentOrReceivable"
    ></add-pay-info-pay-msg-dialog>
  </div>
</template>

<script>
/** 收款/付款信息 */

import apis from '@/utils/apis';
import payTypeDialog from '@/pages/fms/components/pay_type_dialog.vue';
import billMixin from './billMixin';
import bindBankFlowDialog from './bind_bank_flow_dialog';
import addPayInfoPublicStep1Dialog from './add_pay_info_public_step1_dialog.vue';
import addPayInfoPublicStep2Dialog from './add_pay_info_public_step2_dialog.vue';
import addPayInfoPayMsgDialog from './add_pay_info_pay_msg_dialog.vue';

export default {
  name: '',
  mixins: [billMixin],
  components: { bindBankFlowDialog, payTypeDialog, addPayInfoPublicStep1Dialog, addPayInfoPublicStep2Dialog, addPayInfoPayMsgDialog },
  props: {
    // 交易方式-传入则限制交易方式选择（无付款信息情况下）
    tradeMethod: [Number, String],
    // 外部应付列表选中项-必填项
    outerItem: {
      type: Object
    },
    tableCode: {
      type: String,
      default: 'fms_add_msg_bill'
    },
    // 1:查收入流水 0：查付款流水
    sellerTradeType: {
      type: Number,
      default: 1
    },
    // false-收款  true-付款
    paymentOrReceivable: {
      type: Boolean,
      default: false
    },
    //  应收金额合计
    payableTotal: {
      type: Number,
      default: 0
    },
    // 是否使用余额
    isUseBalance: {
      type: Boolean,
      default: false
    },
    // 可使用余额
    balance: {
      type: Number,
      default: 0
    },
    // 账单详情-预算结余|操作人|操作时间时必填
    billInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    // 是否展开流水信息
    expandFlowMsg: {
      type: Boolean,
      default: false
    },
    // 是否反转应付，应收账号显示
    isReverse: {
      type: Boolean,
      default: false
    },
    paymentClass: [Number, String],
    // 权限-账户管理, 默认有
    accountManage: {
      type: Boolean,
      default: true
    },
    // 是否为退款账单
    isRefundBill: {
      type: Boolean,
      default: false
    },
    // 添加交易信息时，给form添加的默认信息
    addPaymentInfoForm: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    formatedList() {
      const data = this.data;
      return data.map((item) => {
        const ret = {
        };
        ret.payMsg = this.getPayMsg(item);
        ret.receiveMsg = this.getReceiveMsg(item);
        ret.tradeMsg = this.getTradeMsg(item);
        return ret;
      });
    },

    expandRowKeys() {
      const data = this.data || [];
      const ret = data.filter(item => item.sellerTradeCode).map(item => item.tradeId);
      // const ret = data.map(item => item.tradeId);
      return ret;
    },

    total() {
      return this.getTotal('totalAmount');
    },

    // 用于计算新增付款信息时，所需要的金额
    amount() {
      const isUseBalance = this.isUseBalance;
      const balance = isUseBalance ? this.balance : 0;
      const payableTotal = this.payableTotal || 0;
      const total = this.total || 0;
      return Math.max(payableTotal - total - balance, 0);
    }

  },
  data() {
    return {
      expandKeys: [],
      totalAmount: '',
      userType: [],
      tableList: [],
      showActionAuth: ['del', 'edit', 'relativeFlow'],
      fullAuth: [
        // 编辑
        'edit',
        // 删除
        'del',
        // 添加 付款/收款信息
        'addPayMsg',
        // 关联流水
        'relativeFlow'
      ],
      defaultAuth: [],
      dialogVisible: false,
      dialogModel: {},
      editIndex: 0,
      imgPreviewData: [],
      showImgPreview: false,
      showBalanceDetail: false,
      // 关联银行流水
      dialogVisible2: false,
      dialogModel2: {},
      sellerAccountList: [],
      buyerAccountList: [],

      payTypeDialogVisible: false,

      addPayInfoPublicStep1DialogVisible: false,
      addPayInfoPublicStep2DialogVisible: false,
      addPayInfoPayMsgDialogVisible: false,

      payInfoModel: {},
    };
  },
  watch: {
    expandRowKeys: {
      immediate: true,
      handler(val) {
        setTimeout(() => {
          if (val) {
            this.expandKeys = val || [];
          }
        }, 500);
      }
    }
  },
  filters: {
    tradeRemark(val) {
      if (!val) {
        return '-';
      }
      return val.slice(-6);
    }
  },
  directives: {},
  methods: {
    rowClassName({ row }) {
      if (this.expandFlowMsg) {
        return row.sellerTradeCode ? '' : 'close-expand';
      }
      return '';
    },
    onAddBuyerMsg() {
      this.getBuyerAccountList();
    },
    onAddSellerMsg() {
      this.getSelllerAccountList();
    },
    onEditBuyerMsg(form) {
      const { buyerAccount } = this.payInfoModel.data.form;
      const buyerAccountList = this.buyerAccountList;
      const item = buyerAccountList.find(obj => obj.depositNumber === buyerAccount);
      if (item) {
        // 如果已有的账号号码被修改，则要同步最新的账号信息
        if (item.bankcardId === form.bankcardId) {
          this.data[this.editIndex].buyerAccount = form.depositNumber;

          this.getBuyerAccountList();
        }
      }
    },
    onEditSellerMsg(form) {
      const { sellerAccount } = this.payInfoModel.data.form;
      const sellerAccountList = this.sellerAccountList;
      const item = sellerAccountList.find(obj => obj.depositNumber === sellerAccount);
      if (item) {
        // 如果已有的账号号码被修改，则要同步最新的账号信息
        if (item.bankcardId === form.bankcardId) {
          this.data[this.editIndex].sellerAccount = form.depositNumber;

          this.getSelllerAccountList();
        }
      }
    },
    getRowId(row) {
      return row.tradeId;
    },
    // 现金不需要绑定银行流水
    bindFlowEnable(row) {
      if (this.dicMap.payment_class) {
        if (`${row.tradeMethod}` === `${this.dicMap.payment_class.cash}`) {
          return false;
        }
      }
      return true;
    },
    getRowKey(row) {
      return row.tradeId;
    },
    onEditPayInfoHandler(row) {
      const index = this.editIndex;
      this.splice(index, 1, row);
    },
    step1Confirm(data) {
      this.addRow(data);
      this.$emit('store', data);
      this.editIndex = this.data.length - 1;
    },
    onPayTypeConfirm(type) {
      this.payTypeDialogVisible = false;
      setTimeout(() => {
        this.payInfoModel = {
          title: this.$t('fms_accounts_registration_msg_bill.tian_jia_jiao_yi'),
          type: 'add',
          data: {
            outerItem: this.outerItem,
            form: {
              tradeMethod: this.tradeMethod
            }
          }
        };
        if (type === 'account') {
          this.addPayInfoPublicStep1DialogVisible = true;
        } else {
          this.addPayInfoPayMsgDialogVisible = true;
        }
      }, 300);
    },
    // 获取流水信息
    getTradeMsg(row) {
      const billInfo = this.billInfo || {};
      const { tradeSellerBos = [] } = billInfo;
      const { sellerTradeCode } = row;
      let ret = {};
      const obj = tradeSellerBos.find(item => item.sellerTradeCode === sellerTradeCode);
      if (obj) {
        ret = obj;
      }

      return ret;
    },
    getPayMsg(row) {
      const accountList = this.buyerAccountList;
      const accountKey = 'buyerAccount';
      const nameKey = 'buyerName';

      const obj = accountList.find(item => item.depositNumber === row[accountKey]);
      const ret = {
        bank: row.buyerBank,
        // 账户名称
        accountName: row[nameKey],
        // 银行账户
        account: row[accountKey]
      };
      if (obj) {
        const {
          // 支行
          depositBank,
        } = obj;

        // 开户行
        ret.bank = depositBank;
      }
      return ret;
    },
    // 获取收款信息
    getReceiveMsg(row) {
      const accountList = this.sellerAccountList;
      const accountKey = 'sellerAccount';
      const nameKey = 'sellerName';

      const obj = accountList.find(item => item.depositNumber === row[accountKey]);
      const ret = {
        bank: row.sellerBank,
        accountName: row[nameKey],
        account: row[accountKey]
      };
      if (obj) {
        const {
          // 支行
          depositBank,
        } = obj;

        // 开户行
        ret.bank = depositBank;
      }
      return ret;
    },
    // 获取收款方账户列表
    getSelllerAccountList() {
      const firstItem = this.outerItem;
      return this.$getJSON(apis.PartnerBankcardListByOrgId, {
        orgId: firstItem.receivableOrgId
      }).then((res) => {
        this.sellerAccountList = res.data;
      });
    },
    // 获取付款方账户列表
    getBuyerAccountList() {
      const firstItem = this.outerItem;
      return this.$getJSON(apis.PartnerBankcardListByOrgId, {
        orgId: firstItem.payableOrgId
      }).then((res) => {
        this.buyerAccountList = res.data;
      });
    },
    addPaymentInfo() {
      if (this.paymentClass) {
        const tradeList = this.data;
        const firstItem = tradeList[0];
        this.payInfoModel = {
          title: this.$t('fms_accounts_registration_msg_bill.tian_jia_jiao_yi'),
          type: 'add',
          data: {
            outerItem: this.outerItem,
            form: {
              tradeMethod: firstItem ? firstItem.tradeMethod : this.tradeMethod,
              ...this.addPaymentInfoForm,
            },
            orderNum: this.getPaymentCode(this.billInfo)
          }
        };
        // 是否为公账类型
        const isPublicAccount = `${this.dicMap.payment_class.public_account}` === `${this.paymentClass}`;
        if (isPublicAccount) {
          this.addPayInfoPublicStep1DialogVisible = true;
        } else {
          this.addPayInfoPayMsgDialogVisible = true;
        }
      } else {
        // 支持公账与现金混合支付
        this.payTypeDialogVisible = true;
      }

    },
    // 删除
    del(scope) {
      this.delRow(scope.$index);
    },
    edit(scope) {
      const row = scope.row;
      const form = { ...row };
      // 未上传文件且进行了保存的交易信息中，tradeId会导致交易信息dialog中的文件重新加载文件.
      if (form.attachs && form.attachs.length) {
        delete form.tradeId;
      }

      this.editIndex = scope.$index;
      this.payInfoModel = {
        title: this.$t('fms_accounts_registration_msg_bill.bian_ji_jiao_yi'),
        type: 'edit',
        data: {
          outerItem: this.outerItem,
          form: form,
          orderNum: this.getPaymentCode(this.billInfo)
        }
      };
      // 如果当前row是现金类型，打开现金付款信息编辑dialog
      // 如果当前row是公账类型，打开工作付款信息编辑dialog
      const isAccount = `${row.tradeMethod}` === `${this.dicMap.payment_class.public_account}`;
      if (isAccount) {
        this.addPayInfoPublicStep2DialogVisible = true;
      } else {
        this.addPayInfoPayMsgDialogVisible = true;
      }
    },
    // 关联流水
    relative(row) {
      this.dialogModel2 = {
        data: row
      };
      this.dialogVisible2 = true;
    },
    // 取消关联流水
    onDelBankFlow(index, isLocal) {
      const tips = this.isRefundBill ? this.$t('fms_accounts_registration_msg_bill.nqdqxxzjyjldtkxm') : this.$t('fms_accounts_registration_msg_bill.nqdqxxzjyjldyskxm');
      this.$showConfirm(tips).then(() => {
        const curBankFlow = this.data[index];
        if (isLocal) {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success')
          });
          const sellerTradeCode = curBankFlow.sellerTradeCode;
          curBankFlow.sellerTradeCode = '';
          this.$emit('success', { type: 'delete', sellerTradeCode: sellerTradeCode }, true);
          return;
        }
        this.$postJSON(`${apis.paymentBankFlowDelete}/${curBankFlow.sellerTradeCode}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success')
          });
          this.$emit('success', { type: 'delete', sellerTradeCode: curBankFlow.sellerTradeCode });
          curBankFlow.sellerTradeCode = '';
        });
      });
    },
    // 确定关联流水（需考虑本地情况）
    onBind(bankItem, isLocal) {
      this.$set(this.dialogModel2.data, 'sellerTradeCode', bankItem.sellerTradeCode);
      this.$set(this.dialogModel2.data, 'receiveRemark', bankItem.buyerTradeRemark);
      this.$set(this.dialogModel2.data, 'receiveTime', bankItem.tradeFinishTime);
      this.$emit('success', bankItem, isLocal);
    },
    onAdd(newData) {
      this.addRow(newData);
    },
    onEdit(newData) {
      this.splice(this.editIndex, 1, newData);
    },
    // 查看交易凭证
    onPreview(scope) {
      this.imgPreviewData = scope.row.attachs;
      this.showImgPreview = true;
    },

    async init() {
      await Promise.all([
        this.getSelllerAccountList(),
        this.getBuyerAccountList()
      ]);
      this.getDicMap('payment_class');
    }

  },
  created() { },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss">
.accounts-registration-msg-bill {
  .check-balance {
    text-decoration: underline;
    display: inline-block;
  }

  .msg-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .red-font {
    color: #ff5c5b;
  }

  .close-expand {
    .el-table__expand-icon {
      display: none;
    }
  }
}
</style>
